import {
	Change,
	ChangeEpisodicItem,
	ChangeScene,
	Character,
	CharScene,
	CmChangePicture,
	HaChange,
	HaChangeScene,
	HaLookPicture,
	MuChange,
	MuChangeScene,
	MuLookPicture,
	PropScene,
} from '../..';

export interface DestroyAllCharactersResults {
	Change?: Change[];
	ChangeEpisodicItem?: ChangeEpisodicItem[];
	ChangeScene?: ChangeScene[];
	Character?: Character[];
	CharScene?: CharScene[];
	CmChangePicture?: CmChangePicture[];
	HaChange?: HaChange[];
	HaChangeScene?: HaChangeScene[];
	HaLookPicture?: HaLookPicture[];
	MuChange?: MuChange[];
	MuChangeScene?: MuChangeScene[];
	MuLookPicture?: MuLookPicture[];
	PropScene?: PropScene[];
}
